import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper/bundle";

export default class extends Controller {
  connect() {
    // Find the swiper container within this controller's element
    const swiperContainer = this.element.querySelector(".swiper");

    if (!swiperContainer) return;

    // Only initialize Swiper if content is wider than viewport
    if (swiperContainer.scrollWidth > window.innerWidth) {
      this.swiper = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 20,
        speed: 500,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },
        pagination: {
          el: ".mpi-poster-pagination",
          clickable: true,
        },
      });
    }
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
